<template>
  <div class="v-window-item py-6 px-3 py-md-12 px-md-6 px-lg-12 v-window-item--active justify-center" style="min-width: 100%; height: 100%">
    <div class="mx-auto v-sheet theme--light" style="min-width: 50%; max-width: 1230px">
      <Loader :messageSelector="messageSelector" :overlay="overlay" />
      <v-form ref="form" v-model="valid">
        <fieldset>
          <legend class="text-h6 text-sm-h5">
            <Ressource code="UIEI_2" />
          </legend>
          
          <Ressource code="UIEI_1" />

          <v-container>
            <!-- Signalant et ou client -->
            <div class="pt-10">
                <h4 class="mb-5">Signalant et ou client</h4>
                <v-row>
                    <!-- Nom Signalant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="nomSignalant" v-model="formulaire.nomSignalant" />
                    </v-col>
                    <!-- Prénom Signalant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="prenomSignalant" v-model="formulaire.prenomSignalant" />
                    </v-col>
                    <!-- Langue Signalant -->
                    <v-col sm="12" md="6" class="py-0">
                        <Catalogue code="langueSignalant" v-model="formulaire.langueSignalant" />
                    </v-col>
                    <!-- Courriel Signalant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="courrielSignalant" v-model="formulaire.courrielSignalant" :rules="rules.courriel" />
                    </v-col>
                    <!-- Cellulaire signalant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="cellulaireSignalant" v-model="formulaire.cellulaireSignalant" />
                    </v-col>
                    <!-- Adresse Signalant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="adresseSignalant" v-model="formulaire.adresseSignalant" />
                    </v-col>
                    <!-- Garder l'anonymat ? -->
                    <v-col sm="12" md="6" class="py-0">
                        <Catalogue code="garderAnonymat" v-model="formulaire.garderAnonymat" />
                    </v-col>
                    <!-- Êtes-vous également le client ? -->
                    <v-col sm="12" md="6" class="py-0">
                        <Catalogue code="etesVousEgalementLeClient" v-model="formulaire.etesVousEgalementLeClient" />
                    </v-col>
                </v-row>
            </div>

            <!-- Intervenant visé -->
            <div class="pt-10">
                <h4 class="mb-5">Intervenant visé</h4>
                <v-row>
                    <!-- Nom Intervenant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="nomIntervenant" v-model="formulaire.nomIntervenant" />
                    </v-col>
                    <!-- Prénom Intervenant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="prenomIntervenant" v-model="formulaire.prenomIntervenant" />
                    </v-col>
                    <!-- Organisme Intervenant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="organismeIntervenant" v-model="formulaire.organismeIntervenant" />
                    </v-col>
                    <!-- Adresse du lieu de travail Intervenant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="adresseIntervenant" v-model="formulaire.adresseIntervenant" />
                    </v-col>
                    <!-- Téléphone au travail Intervenant -->
                    <v-col sm="12" md="6" class="py-0">
                        <TextField code="telephoneIntervenant" v-model="formulaire.telephoneIntervenant" />
                    </v-col>
                     <!-- Courriel Intervenant -->
                     <v-col sm="12" md="6" class="py-0">
                        <TextField code="courrielIntervenant" v-model="formulaire.courrielIntervenant" :rules="rules.courriel" />
                    </v-col>
                    <!-- Membre OTST Intervenant -->
                    <v-col sm="12" md="6" class="py-0">
                        <Catalogue code="membreOTSTIntervenant" v-model="formulaire.membreOTSTIntervenant" />
                    </v-col>
                    <!-- Catégorie(s) du reproche(s) -->
                    <v-col sm="12" md="6" class="py-0">
                        <Catalogue code="categoriesDuReproche" v-model="formulaire.categoriesDuReproche" />
                    </v-col>
                    <!-- TSTCF Intervenant -->
                    <v-col sm="12" md="6" class="py-0" v-if="showTSTCFIntervenant">
                        <Catalogue code="TSTCFIntervenant" v-model="formulaire.TSTCFIntervenant" />
                    </v-col>
                </v-row>
            </div>

            <!-- Exercice illégal -->
            <div class="pt-10" v-if="showActivitesReservees">
                <h4 class="mb-5">Exercice illégal</h4>
                <v-row>
                    <!-- Activité(s) réservée(s) visée(s) -->
                    <v-col sm="12" md="12" class="py-0">
                        <Catalogue code="activitesReservees" v-model="formulaire.activitesReservees" :items="activitesReservees" />
                    </v-col>
                </v-row>
            </div>

            <!-- Reproche(s): (ou quand comment) -->
            <div class="pt-10">
                <h4 class="mb-5">Reproche(s): (ou quand comment)</h4>
                <v-row>
                    <!-- Date de début des faits -->
                    <v-col sm="12" md="6" class="py-0">
                        <DatePicker code="dateDebutFaits" v-model="formulaire.dateDebutFaits" :allowedDates="datesDebutFaitsAutorisees" />
                    </v-col>
                    <!-- Date de fin des faits -->
                    <v-col sm="12" md="6" class="py-0" v-if="showDateFinFaits">
                        <DatePicker code="dateFinFaits" v-model="formulaire.dateFinFaits" :allowedDates="datesFinFaitsAutorisees" />
                    </v-col>
                    <!-- Lieu (ou) et Nature -->
                    <v-col sm="12" md="12" class="py-0">
                        <Memo code="allegationsLieuEtNature" v-model="formulaire.allegationsLieuEtNature" />
                    </v-col>
                </v-row>
            </div>

            <div class="pt-10">
                <v-row>
                <v-col>
                    <FileUploader
                        ref="fileUploader"
                        label="Téléchargement des documents"
                        :multiple="true"
                        :minRequired="0"
                        :rule="rules.files"
                        @filesUploaded="processUpload($event)"
                    />
                </v-col>
                </v-row>
            </div>

            <!-- Approbation -->
            <div class="py-10">
              <CaseACocher code="jApprouveLaTransmission" v-model="formulaire.jApprouveLaTransmission" />
            </div>

            <Ressource code="UIEI_3" />

            <v-row>
              <v-col>
                <v-snackbar :timeout="10000" :value="successTransmission" absolute color="success"> Votre demande a bien été transmise. </v-snackbar>
              </v-col>
            </v-row>
          </v-container>
        </fieldset>
      </v-form>

      <div class="text-right">
        <v-btn color="primary" :disabled="!valid" @click="save()">Soumettre votre demande</v-btn>
      </div>
    </div>

    <v-snackbar v-model="errorBar.error" elevation="24" color="blue-grey" timeout="-1" multi-line class="mb-8">
      {{ errorBar.message }}<br />
      {{ errorBar.detailMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="warning" v-bind="attrs" @click="errorBar.error = false"> {{ $t("error.close") }} </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Loader from "@/components/Loader.vue"
import { PublicApi } from "@/plugins/api"
import FileUploader from "@/components/common/FileUploader.vue"
import ParamFormulaireBase from "@/components/ui/mixins/ParamFormulaireBase"
import Ressource from "@/components/ui/Ressource.vue"
import TextField from "@/components/ui/TextField.vue"
import Catalogue from "@/components/ui/Catalogue.vue"
import DatePicker from "@/components/ui/DatePicker.vue"
import CaseACocher from "@/components/ui/CaseACocher.vue"
import Memo from "@/components/ui/Memo.vue"

export default {
  mixins: [ParamFormulaireBase],
  components: { FileUploader, Loader, Ressource, TextField, Catalogue, DatePicker, CaseACocher, Memo },
  data() {
    return {
      successTransmission: false,
      overlay: false,
      messageSelector: "",
      valid: false,
      errorBar: {
        error: false,
        message: null,
        detailMessage: null
      },
      formulaire: {
        nomSignalant: "",
        prenomSignalant: "",
        langueSignalant: [],
        courrielSignalant: "",
        cellulaireSignalant: "",
        adresseSignalant: "",
        garderAnonymat: [],
        etesVousEgalementLeClient: [],

        nomIntervenant: "",
        prenomIntervenant: "",
        organismeIntervenant: "",
        adresseIntervenant: "",
        telephoneIntervenant: "",
        courrielIntervenant: "",
        membreOTSTIntervenant: [],
        categoriesDuReproche: [],
        TSTCFIntervenant: [],

        activitesReservees: [],
        dateDebutFaits: "",
        dateFinFaits: "",
        allegationsLieuEtNature: "",

        jApprouveLaTransmission: false,

        files: [],
      },
      rules: {
        requis: [(v) => !!v || "Cette valeur est requise"],
        courriel: [(v) => !!v || "Le courriel est requis", (v) => this.validateEmail(v) || "Le format du courriel est invalide"],
        content: [(v) => !!v || "Le contenu de la demande est requis"],
        files: [(v) => this.validateFiles(v)],
      }
    }
  },
  async mounted() {
    await this.loadParams(this.$paramFormulaire.codeFormulaireUIEI)
  },
  computed: {
    ...mapGetters(["champs", "catalogues"]),
    // Récupère toutes les activités reservées sans l'élement "aucune activité"
    activitesReservees() {
        if(!this.champs.get("activitesReservees")) {
            return [];
        }
        let activitesReserveesDescId = this.champs.get("activitesReservees").catalogueReference;
        let catalogueActivitesReservees = this.catalogues?.get(activitesReserveesDescId);
        if(catalogueActivitesReservees.length > 0) {
            let indexToRemove = catalogueActivitesReservees.findIndex(x => x.code ==="001");
            catalogueActivitesReservees.splice(indexToRemove, 1);
        }
        return catalogueActivitesReservees;
    },
    // Si la selection multiple "categoriesDuReproche" contient au moins une des valeur acceptées, on return true. 
    showActivitesReservees() {
      if(!this.formulaire?.categoriesDuReproche?.length > 0) {
            return false;
        }

        let acceptedValues = 
        [
          this.$catalogues.categoriesDuReproche.ExerciceIllegal, 
          this.$catalogues.categoriesDuReproche.IncitationACommettreUnExerciceIllegal, 
          this.$catalogues.categoriesDuReproche.IncitationAContrevenirAuCodeDeDeontologie,
        ];

        if(!this.formulaire.categoriesDuReproche.some(categorie => acceptedValues.includes(categorie))) {
          return false;
        }

        return true;
    },
    // Si la selection multiple "categoriesDuReproche" contient la valeur acceptée, on return true. 
    showTSTCFIntervenant() {
      if(!this.formulaire?.categoriesDuReproche?.length > 0) {
        return false;
      }

      if(!this.formulaire.categoriesDuReproche.includes(this.$catalogues.categoriesDuReproche.UsurpationDUnTitre)) {
        return false;
      }

      return true;
    },
    showDateFinFaits() {
      return this.formulaire?.dateDebutFaits != null && this.formulaire?.dateDebutFaits != "";
    },
  },
  methods: {
    datesDebutFaitsAutorisees(item) {
      return item <= new Date().toISOString().substr(0, 10)
    },
    datesFinFaitsAutorisees(item) {
      return item >= this.formulaire.dateDebutFaits && item <= new Date().toISOString().substr(0, 10)
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateEmail(courriel) {
      return this.$regexCourriel.test(courriel)
    },
    async save() {

      this.validateForm();

      if (this.valid) {
        this.messageSelector = "Save"
        this.overlay = true

        await PublicApi.postForm(`uiei`, this.formulaire, {
          formSerializer: {
            indexes: true // array indexes format: null - no brackets, false - empty brackets, true - brackets with indexes
          }
        })
          .then(() => {
            this.overlay = false
            this.successTransmission = true
            this.resetForm()
          })
          .catch((reason) => {
            this.handleError(reason)
            this.overlay = false
          })
      }
    },
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form.validate()

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    processUpload(uploadedFiles) {
      this.formulaire.files = uploadedFiles;
    },
    validateFiles(files) {
      if (!files || files.length === 0) {
        // pas de fichiers => ok
        return true
      }

      const totalSize = files.reduce((accumulator, currentValue) => accumulator + currentValue?.size, 0)

      return totalSize < 30 * 1024 * 1024 || "La taille des fichiers doit être inférieure à 30 Mo"
    },
    handleError(detail = null) {
      this.errorBar.error = true
      this.errorBar.message = this.$t("error.message")
      this.errorBar.detailMessage = detail || ""
    },
    resetForm() {
      for (let prop in this.formulaire) {
        this.formulaire[prop] = ""
      }
      this.$refs.fileUploader.clearFiles()
      this.$refs.form?.resetValidation()
    },
  }
}
</script>